import {
  CheckCircle,
  Info,
  Warning,
  WarningCircle,
} from "@phosphor-icons/react";
import type { ToasterProps } from "sonner";

export const toasterProps = {
  position: "bottom-left",
  icons: {
    error: <WarningCircle size={24} />,
    warning: <Warning size={24} />,
    info: <Info size={24} />,
    success: <CheckCircle size={24} />,
  },
  toastOptions: {
    unstyled: true,
    classNames: {
      icon: "size-6 m-0",
      content: "text-base-content",
      toast:
        "flex items-center gap-3 rounded border px-4 py-3.5 shadow w-[--width]",
      description: "text-sm",
      default: "bg-base-100",
      error: "border-error bg-red-50 text-error",
      warning: "border-warning bg-orange-50 text-warning",
      info: "border-info bg-blue-50 text-info",
      success: "border-success bg-green-50 text-success",
    },
  },
} satisfies ToasterProps;
